import ContactForm from "./ContactForm";

const exportObjs = {
  Form: ContactForm,
};

export default exportObjs;
